import OrderHistory from "@/components/account/orderHistory";
import Layout from "@/components/app/layout/index";
import { RestrictedAccountRoute } from "@/components/restrict";

export default function OrderHistoryPage() {
  return (
    <RestrictedAccountRoute>
      <Layout backgroundOverride={true}>
        <OrderHistory />
      </Layout>
    </RestrictedAccountRoute>
  );
}
